
import MainController from '../../../../controller/MainController';
import ViewportUtility from '@/core/utils/viewport/viewportUtil';
import EventDispatcher from '@/core/event/eventDispatcher';
import ViewportEvent from '@/core/utils/viewport/viewportEvents';
import styles from './index.module.scss';
import template from './index.tpl';
import {gsap} from 'gsap';
import map from '@/assets/icons/deutschland_map.svg?raw';

let nextButtonHandler: ((event:Event) => void) | null = null;

export default class Index {

    public _id = 'index';

    private data: any;
    private template: string;
    private map: HTMLElement|null = null;
    private map_east: NodeListOf<HTMLElement>|null = null;
    private next_step_buttons: NodeListOf<HTMLElement>|null = null;
    private target: HTMLElement|null = null;

    constructor(data, topView) {

        this.data = data;
        this.template = template({data: this.data, styles: styles, svg: map});

        nextButtonHandler = (event) => {
            topView.nextStepByProxy(event);
        };

        // EventDispatcher.addEventListener(ViewportEvent.BREAKPOINT_CHANGE, (event) => this.breakPointChange(event));
    }

    init() {

        if (this.next_step_buttons && nextButtonHandler) {
            for (let button of this.next_step_buttons) {
                button.addEventListener('click', nextButtonHandler);
            }
        }


        // disable sharing for this view/step
        MainController.setSharing(false);
    }

    /*
    breakPointChange(event) {
        // react on change if needed
    }
    */
    show(timeline?, previousStep?) {
        /*
         Currently not needed (default fade-in handled by abstractView)
         */
    }

    hide(timeline, nextStep, onComplete) {

        let timelineGroup = [
            gsap.to(['.step > h1, p', this.next_step_buttons], 0.2, {autoAlpha: 0, onComplete: onComplete}),
            gsap.to(['p', this.next_step_buttons], 0.2, {x: 220}),
            // adding tween for map here depending on which step comes next (where map will be next).
        ];

        // only add detail animations if we are above mobile widths.
        if (ViewportUtility.width >= 1024) {
            switch (nextStep) {

                case 'regional':
                    timelineGroup.push(gsap.to(this.map, 0.2, {
                        x: 204,
                        y: 14,
                        width: 243,
                        height: 324.42
                    }));
                    break;

                case 'eastwest':
                    timelineGroup.push(gsap.to(this.map_east, 0.2, {fill: '#6b7173'}));
                    timelineGroup.push(gsap.to(this.map, 0.2, {
                        x: 270,
                        y: 30
                    }));
                    break;

                default:
                    timelineGroup.push(gsap.to(this.map, 0.2, {autoAlpha: 0}));
                    break;
            }
        }


        timeline.add(timelineGroup);
    }

    appendTo(target) {

        this.target = target;

        if (!this.target) {
            return
        }

        this.target.setAttribute('id', this.data.steps.index.id);
        this.target.innerHTML = this.template;

        // used by animations
        this.map = this.target.querySelector('.map > svg');
        this.map_east = this.target.querySelectorAll('#Thüringen, #Sachsen, #Sachsen-Anhalt, #Brandenburg, #Berlin, #Mecklenburg-Vorpommern');

        // needed for functionality
        this.next_step_buttons = this.target.querySelectorAll('.next_step_button');
    }
}
